import { useContext } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { SessionContext } from '../../app/Components/Context/SessionContext';
import { MasterLayout } from '../../_metronic/layout/MasterLayout';
import * as KeyNames from '../api/KeyNames';
import AuthPage from '../pages/Authentication/AuthPage';
import { Logout } from '../pages/Authentication/logout';
import { Error404 } from '../pages/Global/Error404';
import GuardarGarantiaLocatario from '../pages/UserLocatario/Garantias/guardarGarantiaLocatario/guardarGarantiaLocatario';
import SeleccionarContrato from '../pages/UserLocatario/SeleccionarContrato/SeleccionarContrato';
import ExcepcionGarantia from '../pages/UserMall/Garantias/ExcepcionCartaFianza/ExcepcionGarantia';

import RevisionGarantia from '../pages/UserMall/Garantias/RevisionGarantia/RevisionGarantia';
import ViewGarantia from '../pages/UserMall/Garantias/RevisionGarantia/ViewGarantia';
import { PrivateRoutes } from './PrivateRoutes';
import RevisionExcepcionGarantia from '../pages/UserMall/Garantias/ExcepcionCartaFianza/RevisionExcepcionGarantia';
import ViewExcepcionGarantia from '../pages/UserMall/Garantias/ExcepcionCartaFianza/ViewExcepcionGarantia';
import ViewGarantiaLocatario from '../pages/UserLocatario/Garantias/ViewGarantiaLocatario';

const Routes = () => {
    const { session } = useContext(SessionContext);
    let isAuthorized = Boolean(session?.sessionToken);

    const location = useLocation().pathname;
    !location.match(/auth\//g) && localStorage.setItem(KeyNames.PathName, location); //Si no está en /auth/

    return (
        <Switch>
            {!isAuthorized ? (
                // En cualquier ruta que se ingrese, por eso no hay prop Path en Route.
                <Route>
                    <AuthPage />
                </Route>
            ) : (
                /*Si está autorizado y entra a la ruta /login, redirecciona al root page (`/`)*/
                <Redirect from='/auth' to='/' />
            )}

            <Route path='/error/404' component={Error404} />
            <Route path='/logout' component={Logout} />
            <Route path='/locatario/seleccionar-contrato' component={SeleccionarContrato} />

            {!isAuthorized ? (
                /*Redirect to `/auth` when user is not authorized*/
                <Redirect to='/auth/login' />
            ) : (
                <>
                    <MasterLayout>

                        <PrivateRoutes />
                        <Route path='/actualizar_garantia/:id' component={GuardarGarantiaLocatario} />
                        <Route path='/garantias_revision/:id' component={RevisionGarantia} />
                        <Route path='/garantias_view/:id' component={ViewGarantia} />
                        <Route path='/garantias_view_locatario/:id' component={ViewGarantiaLocatario} />
                        <Route path='/garantias_excepcion/:id' component={ExcepcionGarantia} />
                        <Route path='/garantias_revision_excepcion/:id' component={RevisionExcepcionGarantia} />
                        <Route path='/garantias_view_excepcion/:id' component={ViewExcepcionGarantia} />
                    </MasterLayout>
                </>
            )}
        </Switch>
    )
}

export { Routes };

